import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IWorkplacesState } from './workplaces-state';
import { StateSlice } from '../state-slice';
import { IListState } from '../shared/list/list.state';
import { getWorkplaceEntities } from '../shared/entities/entities-selectors';
import { Workplace } from '@core/models/shared/workplace/workplace';

export const selectWorkplaceState = createFeatureSelector<IWorkplacesState>(StateSlice.WORKPLACE);

export const getWorkplaceList = createSelector(
    selectWorkplaceState,
    (state: IWorkplacesState): IListState =>  state.workplaces
);

export const getWorkplaceIds = createSelector(
    selectWorkplaceState,
    (state: IWorkplacesState) =>  state.workplaces.ids
);

export const getViewedWorkplaceId = createSelector(
    selectWorkplaceState,
    (state: IWorkplacesState): string =>  state.viewedWorkplaceId
);

export const getWorkplaces = createSelector(
    getWorkplaceIds, getWorkplaceEntities,
    (workplaceIds: string[], workplaceEntities: { [id: string]: Workplace}) => {
        return workplaceIds.map((workplaceId: string) => workplaceEntities[workplaceId])
    }
);

export const isFetchingWorkplaces = createSelector(
    selectWorkplaceState,
    (state: IWorkplacesState): boolean =>  state.workplaces.isFetching
);

export const isFetchingMoreWorkplaces = createSelector(
    selectWorkplaceState,
    (state: IWorkplacesState): boolean =>  state.workplaces.isFetchingMore
);

export const hasMoreWorkplaces = createSelector(
    selectWorkplaceState,
    (state: IWorkplacesState): boolean =>  state.workplaces?.meta?.has_next || false
);

export const getViewedWorkplace = createSelector(
    getViewedWorkplaceId, getWorkplaceEntities,
    (workplaceId: string, workplaceEntities: { [id: string]: Workplace}) => {
        return (workplaceId && workplaceEntities.hasOwnProperty(workplaceId) && workplaceEntities[workplaceId]) || null;
    }
);
